// ScrollReveal.js
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { useEffect } from "react";

const ScrollReveal = ({
  children,
  delay = 0,
  duration = 0.8,
  animation = "fade-up", // options: "fade-up", "zoom-in"
  yOffset = 50,
}) => {
  const controls = useAnimation();
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  useEffect(() => {
    if (inView) {
      controls.start("visible");
    }
  }, [controls, inView]);

  const variants = {
    "fade-up": {
      hidden: { opacity: 0, y: yOffset },
      visible: { opacity: 1, y: 0 },
    },
    "zoom-in": {
      hidden: { opacity: 0, scale: 0.8 },
      visible: { opacity: 1, scale: 1 },
    },
  };

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={controls}
      transition={{ duration, delay }}
      variants={variants[animation]}
    >
      {children}
    </motion.div>
  );
};

export default ScrollReveal;
